import { Fragment } from 'react';
import styled from 'styled-components';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import LayoutSortableCollectionView from '../LayoutCollectionView/LayoutSortableCollectionView';
import ShopCard from '../ShopCard/ShopCard';
import { GRID, SHOPS } from '../../../../lib/constants';
import { makeExternalUrl } from '../../../../lib/utils';
import { saveShop, removeShopById } from '../../../../lib/user';

const HiddenH1 = styled.h1`
  display: none;
`;

const HeroBackgroundWrapper = styled.div`
  background: ${({ theme }) => theme.c.bg['feature-2']};
  ${({ heroImageUrl }) => heroImageUrl && `
    background: url("${heroImageUrl}");
    background-size: cover;
  `}
  color: ${({ theme, heroFontColor }) => heroFontColor || theme.c.text.primary};

  padding: 132px 0;
`;

const HeroHeading = styled.h2`
  margin: 0 0 ${({ theme }) => theme.unit(2)} 0;
  
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  text-align: center;
`;

const HeroSubheading = styled.p`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  text-align: center;
`;

const getFeaturedSortFn = (featuredShopsSlugs) => (shops) => {
  const featuredShops = [];
  const restShops = [];
  const bonusMilesSlugsSet = new Set(
    shops.map((shop) => shop.slug)
  );

  const featuredShopIndexBySlug = featuredShopsSlugs
    .filter((featuredShopSlug) => bonusMilesSlugsSet.has(featuredShopSlug))
    .reduce((acc, shopsSlug, index) => {
      acc[shopsSlug] = index;
      return acc;
    }, {});

  shops.forEach((shop) => {
    if (shop.slug in featuredShopIndexBySlug) {
      featuredShops[featuredShopIndexBySlug[shop.slug]] = shop;
    } else {
      restShops.push(shop);
    }
  });

  const sortedRest = restShops.sort(
    (a, b) => (a.name || '').localeCompare((b.name || ''), undefined, { sensitivity: 'base' })
  );

  return [...featuredShops, ...sortedRest];
};

const BonusMilesPageContent = ({
  bonusMilesPageData,
  bonusMilesShops,
  pageStateModifiers,
  pageTitle,
  locale,
  userData,
}) => {
  const {
    heroHeading,
    heroSubheading,
    heroImageUrl,
    heroFontColor,
    shopsLayoutTitle,
    shopsLayoutButtonText,
    shopsLayoutButtonUrl,
    sortByLabel,
    featuredSortOption,
    nameAscSortOption,
    nameDescSortOption,
    featuredShops,
  } = bonusMilesPageData;

  const sortingConfig = {
    'featured-first': {
      label: featuredSortOption,
      getSortedArray: getFeaturedSortFn(featuredShops.map(({ slug }) => slug)),
    },
    'name-ASC': {
      label: nameAscSortOption,
      getSortedArray: (shops) => (
        [...shops].sort(
          (a, b) => (a.name || '').localeCompare((b.name || ''), undefined, { sensitivity: 'base' })
        )
      ),
    },
    'name-DESC': {
      label: nameDescSortOption,
      getSortedArray: (shops) => (
        [...shops].sort(
          (a, b) => (b.name || '').localeCompare((a.name || ''), undefined, { sensitivity: 'base' })
        )
      ),
    },
  };

  const favShops = userData
    ? userData.shops || []
    : [];
  const favShopIds = favShops.map((shop) => shop.id);

  return (
    <Fragment>
      <HiddenH1>{pageTitle}</HiddenH1>
      <HeroBackgroundWrapper
        heroImageUrl={makeExternalUrl(heroImageUrl)}
        heroFontColor={heroFontColor}
      >
        <MaxWidthLayout key="bonus-miles--hero-heading">
          <HeroHeading>{heroHeading}</HeroHeading>

          <HeroSubheading>{heroSubheading}</HeroSubheading>
        </MaxWidthLayout>
      </HeroBackgroundWrapper>

      <MaxWidthLayout key="bonus-miles--bonus-shops">
        <LayoutSortableCollectionView
          sortingConfig={sortingConfig}
          sortingLabel={sortByLabel}
          sectionTitle={shopsLayoutTitle}
          showDisplayName
          styleDesktop={{ marginLeft: '0px' }}
          buttonText={shopsLayoutButtonText}
          buttonUrl={shopsLayoutButtonUrl}
          favItemIds={favShopIds}
          items={bonusMilesShops}
          Comp={ShopCard}
          itemType={SHOPS}
          viewType={GRID}
          saveItemHandler={saveShop}
          removeItemHandler={removeShopById}
          pageStateModifiers={pageStateModifiers}
          locale={locale}
          pageContext="shop-group--bonus-miles"
        />
      </MaxWidthLayout>
    </Fragment>
  );
};

export default BonusMilesPageContent;
